import React, { useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch
} from 'react-router-dom';

import { Layout } from './design';
import Users from './users';
import App from './app';
import Login from './login';
import ForgotPassword from './forgotPassword';
import Registration from './registration';
import UpdatePassword from './updatePassword';
import UserApproval from './userApproval';
import BulkUpload from './bulkUpload';
import SignContract from './signContract';
import SignIotContract from './iot/signContract';
import Success from './signContract/success';
import SuccessIot from './iot/signContract/success';
import SuccessBA from './businessApps/signinContract/success'
import SignBAContract from './businessApps/signinContract'
import Expired from './signContract/expired';
import OrderTracking from './orderTracking';
import ViewSignedContract from './viewSignedContract';
import { PrivateRoute, PublicRoute } from './routeHandler';
import DefectManagement from './defectManagement';

import {
  addLocale,
  defaultLocale,
  getPathVariables,
  getUrlWithoutLocale,
  localeEn,
  localeFr,
  pages
} from './misc';
import LogDefect from './logDefect';
import PortingTool from './checkServicesTool';

import { useLocaleContext } from './context/LocaleContext';
import { useLocalizedStringsContext } from './context/LocalizedStringsContext';
import request from './utils/request';

const Routes = () => {
  const {
    location: { pathname, search }
  } = window;
  const locale = useLocaleContext();
  const addLocaleToUrl = addLocale(locale);
  const [profile, setProfile] = useState();
  if (locale && ![localeEn, localeFr].includes(locale)) {
    window.location = addLocale(defaultLocale)(pathname.concat(search));
  }
  const updateProfile = () => {
    const { getProfile } = request;
    setProfile(getProfile());
  };

  useEffect(() => {
    const oldLocale = getPathVariables(window.location.pathname)[0];
    updateProfile();
    if (oldLocale && oldLocale !== locale) {
      const urlWithoutLocale = getUrlWithoutLocale(oldLocale)(
        window.location.pathname
      );
      window.location.pathname =
        urlWithoutLocale !== pages.HOME
          ? addLocaleToUrl(`/${urlWithoutLocale}${search}`)
          : addLocaleToUrl('/');
    }
  }, [locale]);

  const localizedStrings = useLocalizedStringsContext();
  const {
    USERS: {
      USER_AUTHENTICATION: {
        labels: { TELUS_HEADING }
      }
    }
  } = localizedStrings;

  useEffect(() => {
    document.title = TELUS_HEADING;
  }, [localizedStrings]);

  return (
    <>
      <Router>
        <Layout locale={locale} profile={profile}>
          <Switch>
            <Route
              path={pages.HOME}
              render={() => <Redirect to={addLocale(locale)(pages.HOME)} />}
              exact
            />
            <PublicRoute
              path={addLocaleToUrl('/sign-iot-contract/success')}
              component={SuccessIot}
            />
            <Redirect
              from="/sign-iot-contract/success"
              to={addLocaleToUrl('/sign-iot-contract/success')}
            />
            <PublicRoute
              path={addLocaleToUrl('/sign-iot-contract/expired')}
              component={Expired}
            />
            <Redirect
              from="/sign-iot-contract/expired"
              to={addLocaleToUrl('/sign-iot-contract/expired')}
            />

            <PublicRoute
              path={addLocaleToUrl('/sign-iot-contract')}
              component={SignIotContract}
            />
            <Redirect
              from="/sign-iot-contract/:token"
              to={addLocaleToUrl('/sign-iot-contract')}
            />

            <PublicRoute
              path={addLocaleToUrl('/sign-ba-contract/success')}
              component={SuccessBA}
            />
            <Redirect
              from="/sign-ba-contract/success"
              to={addLocaleToUrl('/sign-ba-contract/success')}
            />
            <PublicRoute
              path={addLocaleToUrl('/sign-ba-contract/expired')}
              component={Expired}
            />
            <Redirect
              from="/sign-ba-contract/expired"
              to={addLocaleToUrl('/sign-ba-contract/expired')}
            />

            <PublicRoute
              path={addLocaleToUrl('/sign-ba-contract')}
              component={SignBAContract}
            />
            <Redirect
              from="/sign-ba-contract/:token"
              to={addLocaleToUrl('/sign-ba-contract')}
            />
            <PublicRoute
              path={addLocaleToUrl('/sign-contract/success')}
              component={Success}
            />
            <Redirect
              from="/sign-contract/success"
              to={addLocaleToUrl('/sign-contract/success')}
            />
            <PublicRoute
              path={addLocaleToUrl('/sign-contract/expired')}
              component={Expired}
            />
            <Redirect
              from="/sign-contract/expired"
              to={addLocaleToUrl('/sign-contract/expired')}
            />

            <PublicRoute
              path={addLocaleToUrl('/sign-contract')}
              component={SignContract}
            />
            <Redirect
              from="/sign-contract/:token"
              to={addLocaleToUrl('/sign-contract')}
            />
            <PublicRoute
              path={addLocaleToUrl('/view-signed-contract')}
              component={ViewSignedContract}
            />
            <Redirect
              from="/view-signed-contract/:token"
              to={addLocaleToUrl('/view-signed-contract')}
            />
            <PublicRoute
              path={addLocaleToUrl('/order-tracking')}
              component={OrderTracking}
            />
            <Redirect
              from="/order-tracking/:token"
              to={addLocaleToUrl('/order-tracking')}
            />
            <Redirect from="/login" to={addLocaleToUrl('/login')} />
            <Redirect
              from="/registration"
              to={addLocaleToUrl('/registration')}
            />
            <PrivateRoute
              exact
              path={addLocaleToUrl('/defects')}
              component={DefectManagement}
              locale={locale}
            />
            <Redirect from="/defects" to={addLocaleToUrl('/defects')} />
            <Redirect
              from="/forgot-password"
              to={addLocaleToUrl('/forgot-password')}
            />

            <Redirect
              from="/users/:userId"
              to={addLocaleToUrl('/users/:userId')}
            />
            <PrivateRoute
              exact
              path={addLocaleToUrl('/users/:userId')}
              component={Users}
              locale={locale}
            />
            <Redirect from="/users" to={addLocaleToUrl('/users')} />
            <PrivateRoute
              exact
              path={addLocaleToUrl('/users')}
              component={Users}
              locale={locale}
            />
            <Redirect
              from="/forgot-password"
              to={addLocaleToUrl('/forgot-password')}
            />
            <PublicRoute
              path={addLocaleToUrl('/forgot-password')}
              component={ForgotPassword}
            />
            <Redirect
              from="/update-password"
              to={addLocaleToUrl('/update-password')}
            />
            <Route
              path={addLocaleToUrl('/update-password')}
              render={() => <UpdatePassword updateProfile={updateProfile} />}
            />
            <Redirect from="/bulk-upload" to={addLocaleToUrl('/bulk-upload')} />
            <PrivateRoute
              path={addLocaleToUrl('/bulk-upload')}
              component={BulkUpload}
              locale={locale}
            />
            <Redirect
              from="/confirmation"
              to={addLocaleToUrl('/confirmation')}
            />
            <Route
              path={addLocaleToUrl('/confirmation')}
              component={UserApproval}
            />
            <PublicRoute
              path={addLocaleToUrl('/registration')}
              component={Registration}
            />
            <PublicRoute path={addLocaleToUrl('/login')} component={Login} />
            <Redirect
              from="/report-an-issue"
              to={addLocaleToUrl('/report-an-issue')}
            />
            <PrivateRoute
              exact
              path={addLocaleToUrl('/report-an-issue')}
              component={LogDefect}
              locale={locale}
            />
            <Redirect
              from="/Phone_Number_Portal_Tool/Phone_Number_Portal_Tool/"
              to={addLocaleToUrl(
                '/Phone_Number_Portal_Tool/Phone_Number_Portal_Tool/'
              )}
            />
            <PrivateRoute
              exact
              path={addLocaleToUrl(
                '/Phone_Number_Portal_Tool/Phone_Number_Portal_Tool/'
              )}
              component={PortingTool}
              locale={locale}
            />
            <PrivateRoute component={App} locale={locale} />
          </Switch>
        </Layout>
      </Router>
    </>
  );
};

export default Routes;
